import type { QueryHookOptions } from '@apollo/client';

import {
  type AtsSharedGetCountriesQuery,
  type AtsSharedGetCountriesQueryVariables,
  useAtsSharedGetCountriesQuery as useGetCountriesQuery,
} from './get-countries.v5.generated';

export const useGetCountries = (
  baseOptions?: QueryHookOptions<
    AtsSharedGetCountriesQuery,
    AtsSharedGetCountriesQueryVariables
  >,
  skip?: boolean,
) =>
  useGetCountriesQuery({
    context: {
      clientName: 'v5',
    },
    skip,
    ...baseOptions,
  });
